import React, { useState } from 'react'

const Spinner = ({ size = 20 }) => (
    <span className="sb-spinner" style={{ width: size + 'px', height: size + 'px', display: 'inline-block' }} />
)

export function useElementLoader(size = 20) {
    const loader = <Spinner key="loader" size={size} />
    return [loader]
}

export function usePageLoader(defaultState) {
    const [visible, setVisible] = useState(defaultState)
    const showLoader = () => setVisible(true)
    const hideLoader = () => setVisible(false)
    const loader = visible ? <Spinner size={24} /> : null
    return [loader, showLoader, hideLoader]
}
